import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { SelectField, TextAreaField } from 'FormFields';

const labelColSpan = 4;
const wrapperColSpan = 17;

export default class extends React.PureComponent{

  static propTypes = {
    serviceTypes: PropTypes.array.isRequired,
    submitting: PropTypes.bool.isRequired,
  }

  render () {

    const { serviceTypes, submitting } = this.props;
    const typeOptions = serviceTypes.map(item => ({ label: item.title, value: item.key }));

    return (
      
      <React.Fragment>

        <Field
          name="type"
          label="Type"
          disabled={submitting}
          component={SelectField}
          options={typeOptions}
          labelCol={{ span: labelColSpan }}
          wrapperCol={{ span: wrapperColSpan }}
          required
        />

        <Field
          name="content"
          label="Content"
          disabled={submitting}
          component={TextAreaField}
          labelCol={{ span: labelColSpan }}
          wrapperCol={{ span: wrapperColSpan }}
          style={{ height: 200 }}
          required
        />

      </React.Fragment>

    )
  }
}